import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React, { useState, useEffect, useRef } from 'react';
import { flamingo } from '../colors';
import CheckBoxIcon from '../icons/checkbox';
import DefaultTheme from './theme';
import InfoBubble from '../info-bubble';
export var CheckBoxTheme = DefaultTheme;
/*::
import type { CheckboxThemeType } from './theme';

type Props = {|
  checked?: boolean,
  label?: ?string,
  color?: string,
  checkboxWidth?: number, // should be rems not pixels
  onChange?: (value: boolean) => any,
  helpText?: string;
  theme?: CheckboxThemeType,
  rest?: any,
|};
*/

var Checkbox = function Checkbox(_ref
/*: Props */
) {
  var _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? null : _ref$label,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? flamingo() : _ref$color,
      _ref$checkboxWidth = _ref.checkboxWidth,
      checkboxWidth = _ref$checkboxWidth === void 0 ? 1.8 : _ref$checkboxWidth,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? function () {
    return undefined;
  } : _ref$onChange,
      helpText = _ref.helpText,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["checked", "label", "color", "checkboxWidth", "onChange", "helpText", "theme"]);

  var handleCheckedToggle = function handleCheckedToggle() {
    _onChange(!checked);
  };

  var _useState = useState(false),
      clicked = _useState[0],
      setClicked = _useState[1];

  var checkboxRef = useRef();

  var handleClickOutside = function handleClickOutside(e
  /*: any */
  ) {
    if (checkboxRef && checkboxRef.current && checkboxRef.current.contains(e.target)) {
      // inside click:
      setClicked(true);
      return;
    } // outside click:


    setClicked(false);
  };

  useEffect(function () {
    // register click outside handler
    document.addEventListener('mousedown', handleClickOutside, true); // remove event handlers from the document once component unmounts

    return function () {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, []);
  return /*#__PURE__*/React.createElement(theme.Main, Object.assign({
    color: color
  }, rest), /*#__PURE__*/React.createElement(theme.InlineFlex, {
    ref: checkboxRef,
    "data-test": "checkbox-inline-flex"
  }, /*#__PURE__*/React.createElement(theme.IconWrapper, {
    color: color,
    checkboxWidth: checkboxWidth,
    clicked: clicked,
    "data-test": "checkbox-icon-wrapper"
  }, /*#__PURE__*/React.createElement(CheckBoxIcon, {
    color: color,
    checked: checked,
    width: checkboxWidth,
    "data-test": "checkbox-icon"
  }), /*#__PURE__*/React.createElement(theme.Input, {
    checked: checked,
    onChange: function onChange(e) {
      return _onChange(e.target.checked);
    },
    "data-test": "checkbox-input"
  })), label ? /*#__PURE__*/React.createElement(theme.Label, {
    onClick: handleCheckedToggle,
    "data-test": "checkbox-label"
  }, label) : null, helpText ? /*#__PURE__*/React.createElement(InfoBubble, {
    theme: theme.InfoBubbleTheme
  }, helpText) : null));
};

Checkbox.displayName = 'Checkbox';
export default Checkbox;